import { Injectable, signal } from '@angular/core';

/**
 * Permisos del usuario autenticado. Se cargan al abrir sesión (los traduce el
 * backend desde los componentes de SIGERH) y todo lo que se ve en la app
 * —menú, rutas, botones— pasa por `can()`.
 *
 * Sin permisos NO se ve nada.
 */
@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private readonly permisos = signal<ReadonlySet<string>>(new Set());

  cargar(permisos: readonly string[]): void {
    this.permisos.set(new Set(permisos));
  }

  limpiar(): void {
    this.permisos.set(new Set());
  }

  /** Sin código de permiso la opción es pública (solo requiere sesión). */
  can(permiso?: string): boolean {
    if (!permiso) {
      return true;
    }
    return this.permisos().has(permiso);
  }
}
